import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=81fce4e0&scoped=true"
import script from "./headerCom.vue?vue&type=script&lang=js"
export * from "./headerCom.vue?vue&type=script&lang=js"
import style0 from "./headerCom.vue?vue&type=style&index=0&id=81fce4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fce4e0",
  null
  
)

export default component.exports